export default "__VITE_ASSET__lKHB5pS___"